import { DeliverySpec, IDeliverySpec } from '@/shared/model/delivery-spec.model';
import { IMarketer, Marketer } from '@/shared/model/marketer.model';
import { IRestaurantWorkingTimes } from '@/shared/model/restaurant-working-times.model';
import { IRestaurant } from '@/shared/model/restaurant.model';
import { IUser } from '@/shared/model/user.model';
import { MutationTree } from 'vuex';
import { ISupportStore } from './types';

export const mutations: MutationTree<ISupportStore> = {
  setTab(state, newTab: string): void {
    state.tab = newTab;
  },
  setDrawer(state, newDrawer: boolean): void {
    state.drawer = newDrawer;
  },
  setMarketer(state, newMarketer: IMarketer): void {
    if (newMarketer.moderator) {
      state.marketer = newMarketer;
    } else {
      newMarketer.moderator = new Marketer();
      state.marketer = newMarketer;
    }
  },
  setMarketerDialog(state, newMarketerDialog: boolean): void {
    state.marketerDialog = newMarketerDialog;
  },
  setNewMarketer(state, newMarketer: IMarketer): void {
    state.newMarketer = newMarketer;
  },
  setNewMarketerDialog(state, newMarketerDialog: boolean): void {
    state.newMarketerDialog = newMarketerDialog;
  },
  setRestaurant(state, newRestaurant: IRestaurant): void {
    if (newRestaurant.marketer) {
      state.restaurant = newRestaurant;
    } else {
      newRestaurant.marketer = new Marketer();
      state.restaurant = newRestaurant;
    }
  },
  setDeliverySpecs(state, newDeliverySpecs: IDeliverySpec[]): void {
    state.restaurant.deliverySpecs = newDeliverySpecs;
  },
  setRestaurantDialog(state, newRestaurantDialog: boolean): void {
    state.restaurantDialog = newRestaurantDialog;
  },
  setRestaurantWorkingTimes(state, newRestaurantWorkingTimes: IRestaurantWorkingTimes[]): void {
    state.restaurant.restaurantWorkingTimes = newRestaurantWorkingTimes;
  },
  setNewRestaurant(state, newRestaurant: IRestaurant): void {
    state.newRestaurant = newRestaurant;
  },
  setNewRestaurantDialog(state, newRestaurantDialog: boolean): void {
    state.newRestaurantDialog = newRestaurantDialog;
  },
  setSupport(state, newSupport: IUser): void {
    state.support = newSupport;
  },
  setSupportDialog(state, newSupportDialog: boolean): void {
    state.supportDialog = newSupportDialog;
  },
  setUnregisteredRestaurant(state, newUnregisteredRestaurant: IUser): void {
    state.unregisteredRestaurant = newUnregisteredRestaurant;
  },
  setUnregisteredRestaurantDialog(state, newUnregisteredRestaurantDialog: boolean): void {
    state.unregisteredRestaurantDialog = newUnregisteredRestaurantDialog;
  },
  setUpdatedRestaurant(state, newUpdatedRestaurant: IUser): void {
    state.updatedRestaurant = newUpdatedRestaurant;
  },
  setUpdatedRestaurantDialog(state, newUpdatedRestaurantDialog: boolean): void {
    state.updatedRestaurantDialog = newUpdatedRestaurantDialog;
  },
  setUnregisteredMarketer(state, newUnregisteredMarketer: IUser): void {
    state.unregisteredMarketer = newUnregisteredMarketer;
  },
  setUnregisteredMarketerDialog(state, newUnregisteredMarketerDialog: boolean): void {
    state.unregisteredMarketerDialog = newUnregisteredMarketerDialog;
  },
  addRestaurantWorkingTime(state, { i, deliveryTime }): void {
    deliveryTime.deliverFromHourString
      ? (state.restaurant.restaurantWorkingTimes[i].deliverFromHourString = deliveryTime.deliverFromHourString)
      : (state.restaurant.restaurantWorkingTimes[i].deliverFromHour = new Date());
    deliveryTime.deliverToHourString
      ? (state.restaurant.restaurantWorkingTimes[i].deliverToHourString = deliveryTime.deliverToHourString)
      : (state.restaurant.restaurantWorkingTimes[i].deliverToHour = new Date());
    deliveryTime.pickupFromHourString
      ? (state.restaurant.restaurantWorkingTimes[i].pickupFromHourString = deliveryTime.pickupFromHourString)
      : (state.restaurant.restaurantWorkingTimes[i].pickupFromHour = new Date());
    deliveryTime.pickupToHourString
      ? (state.restaurant.restaurantWorkingTimes[i].pickupToHourString = deliveryTime.pickupToHourString)
      : (state.restaurant.restaurantWorkingTimes[i].pickupToHour = new Date());
  },
  removeRestaurantWorkingTime(state, i: number): void {
    state.restaurant.restaurantWorkingTimes[i].deliverFromHourString = null;
    state.restaurant.restaurantWorkingTimes[i].deliverToHourString = null;
    state.restaurant.restaurantWorkingTimes[i].pickupFromHourString = null;
    state.restaurant.restaurantWorkingTimes[i].pickupToHourString = null;
  },
  addDeliverySpec(state): void {
    state.restaurant.deliverySpecs.push(new DeliverySpec());
  },
  removeDeliverySpec(state, i: number): void {
    state.restaurant.deliverySpecs.splice(i, 1);
  },
  updateRestaurantStateMember(state, { stateMember, i, field, value }): void {
    i !== null ? (state.restaurant[stateMember][i][field] = value) : (state.restaurant[stateMember][field] = value);
  },
  setMenuCard(state, newMenuCard: string[]): void {
    state.restaurant.menuCard = newMenuCard;
  },
  setMenuCardContentType(state, newMenuCardContentType: string): void {
    state.restaurant.menuCardContentType = newMenuCardContentType;
  },
  setIdCard(state, newIdCard: string[]): void {
    state.restaurant.idCard = newIdCard;
  },
  setIdCardContentType(state, newIdCardContentType: string): void {
    state.restaurant.idCardContentType = newIdCardContentType;
  },
  setCocRegistration(state, newCocRegistration: string[]): void {
    state.restaurant.cocRegistration = newCocRegistration;
  },
  setCocRegistrationContentType(state, newCocRegistrationContentType: string): void {
    state.restaurant.cocRegistrationContentType = newCocRegistrationContentType;
  },
  setBankCard(state, newBankCard: string[]): void {
    state.restaurant.bankCard = newBankCard;
  },
  setBankCardContentType(state, newBankCardContentType: string): void {
    state.restaurant.bankCardContentType = newBankCardContentType;
  },
};
